module.exports = __webpack_public_path__ + "static/media/moto_bgr.3d11f996.jpg";